import React from 'react';
import classNames from 'classnames';
import Modal, { ModalButton } from '@components/Modals';
import { ButtonVariant, ConfirmCallback, ConfirmOptions } from '@app/types';

type ConfirmModalState = ConfirmOptions & {
  callback: ConfirmCallback;
  open: boolean;
  active: boolean;
};

export default class Confirm extends React.Component<{}, ConfirmModalState> {
  defaultState = {
    open: false,
    active: false,
    title: 'Are you sure?',
    message: null,
    callback: null,
    action: 'Confirm',
    actions: [],
    variant: 'primary' as ButtonVariant,
    smallModal: true,
    noCancelButton: false,
    forceDarkMode: false,
  };

  state = { ...this.defaultState };

  componentDidMount() {
    window.app.confirm = this.prompt.bind(this);
  }

  prompt(options: ConfirmOptions, callback: ConfirmCallback) {
    this.setState({
      callback,
      ...options,
      open: true,
      active: true,
    });
  }

  handleOpen() {
    window.__activeConfirm = true;
  }

  handleClose(_ = null, value = false) {
    const { callback } = this.state;

    if (callback) {
      callback(value);
    }

    return this.setState({ open: false });
  }

  handleAfterClose() {
    window.__activeConfirm = false;
    this.setState({ ...this.defaultState });
  }

  handleAction(value) {
    this.handleClose(null, value);
  }

  render() {
    const {
      open,
      variant,
      active,
      action,
      actions = [],
      title,
      message,
      smallModal,
      noCancelButton,
      forceDarkMode = false,
    } = this.state;

    return (
      open && (
        <Modal
          isOpen={true}
          overlayClassName="modal-confirm"
          className={classNames(smallModal && 'modal-small')}
          onAfterOpen={this.handleOpen.bind(this)}
          onAfterClose={this.handleAfterClose.bind(this)}
          onRequestClose={this.handleClose.bind(this)}
          forceDarkMode={forceDarkMode}
        >
          {!title ? null : <div className="modal-header">{title}</div>}
          <div className="modal-content-padded">
            {message}
            {!active ? null : (
              <div className="modal-button-row">
                {!noCancelButton && (
                  <ModalButton
                    variant="muted"
                    onClick={this.handleAction.bind(this, false)}
                    tabIndex={0}
                  >
                    Cancel
                  </ModalButton>
                )}
                {actions.length > 0 ? (
                  actions.map(({ title, value, ...props }) => (
                    <ModalButton
                      key={title}
                      {...props}
                      onClick={this.handleAction.bind(this, value)}
                    >
                      {title}
                    </ModalButton>
                  ))
                ) : (
                  <ModalButton
                    variant={variant}
                    onClick={this.handleAction.bind(this, true)}
                    autoFocus
                    tabIndex={0}
                  >
                    {action}
                  </ModalButton>
                )}
              </div>
            )}
          </div>
        </Modal>
      )
    );
  }
}
